import gql from 'graphql-tag'

const statsHomeTableAgenti = gql`
  query statsHomeTableAgenti(
    $daData: Date!,
    $aData: Date!
  ) {
    statsHomeTableAgenti(
      daData: $daData, 
      aData: $aData
    ) {
      nomeAgente
      numeroContattiRicevuti
      numeroContattiInCuiHaFattoAzioni
      numeroTelefonateOut
      numeroEmailOut
      numeroWhatsappOut
      numeroAppuntamentiFissati
      numeroAppuntamentiConfermatiSegretaria
      numeroContattiDaRichiamare
      numeroAppuntamentiDaFare
    }
  }
`

export default statsHomeTableAgenti


// WEBPACK FOOTER //
// ./src/graphql/queries/statsHomeTableAgenti.js